import { Component, OnInit, Input } from '@angular/core';
import { ClientShortModel } from 'src/app/models/client-short.model';
import { UserShortModel } from 'src/app/models/user-short.model';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { IndependenceModel } from '../../declaration.model';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-client-independence',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css'],
})
export class ClientIndependenceComponent implements OnInit {
  financialList;
  employeeList: UserShortModel[];
  clientList: ClientShortModel[];

  selectedProfile = '1';
  selectedEmployee;
  selectedClient;
  @Input() clientIndependence: IndependenceModel;
  @Input() isMyReport: boolean;

  constructor(
    private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService,
    private commonMessageService:CommonMessageService
  ) {}

  ngOnInit(): void {
    this.selectedEmployee="";
    this.selectedClient="";
    console.log("clientIndependence",this.clientIndependence)
    if (!this.isMyReport) {
      this.loadInitDetails();
      this.onProfileChanged();
    }
  }
  loadInitDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onProfileChanged() {
    if (this.selectedProfile != null && this.selectedProfile != undefined) {
      this.masterDataService
        .getUserByProfile(this.selectedProfile)
        .subscribe((res) => {
          this.employeeList = res;
        });
    }
  }

  showExcelButton:Boolean;
  onViewReport() {
    if (
      this.selectedClient == null ||
      this.selectedClient == undefined ||
      this.selectedClient == "" ||
      this.selectedProfile == null ||
      this.selectedProfile == undefined ||
      this.selectedEmployee == null ||
      this.selectedEmployee == undefined || 
      this.selectedEmployee == ""
    )
       this.commonMessageService.swalAlertWithoutIcon('','Please choose the values before pressing report');
    else {
      this.masterDataService
        .getClientIndependence(
          this.selectedClient.clientId,
          this.selectedEmployee.id,
          this.selectedProfile
        )
        .subscribe((res) => {
          //this.reportList =res[0].role;
          this.clientIndependence = res;
          if(this.clientIndependence==null){
             this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");
            this.showExcelButton=false;
          }else{
            this.showExcelButton=true;
          }
          console.log('res',this.clientIndependence);

        });
    }
  }

  onEmployeeSelect() {
    this.selectedClient="";
    if (this.selectedEmployee != null && this.selectedEmployee != undefined && this.selectedEmployee!="") {
      this.masterDataService
        .getClientsForEmployee(this.selectedEmployee.id)
        .subscribe((res) => {
          this.clientList = res;
        });
    }
  }
  validateAggreQuestion(answer){
    if(answer==1){
      return true;
    }else{
      return false;
    }
  }

  onExportToExcelReport(){
    this.masterDataService.getNewClientIndependenceExcel( this.selectedClient.clientId,
      this.selectedEmployee.id,
      this.selectedProfile).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "NewClientDeclaration.xlsx";
      link.click();
    });
  }

  exportToPDFClick(){
    var docDefinition = {
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'Client Independence Confirmation', fontSize: 18, bold: true, alignment: 'center', margin: [0, 15, 0, 15] });
    docDefinition.content.push({text: `Name of Client:${'                                             '}${this.clientIndependence.clientName}`,bold:true,margin: [0, 5, 0, 5]});
    docDefinition.content.push({text: `Legal Status:${'                                                 '} ${this.clientIndependence.legalStatus}`,bold:true,margin: [0, 5, 0, 5]});
    docDefinition.content.push({text: `Branch:${'                                                            '}${this.clientIndependence.branch}`,bold:true,margin:[0, 5, 0, 5]});
    docDefinition.content.push({text: `Client Added on:${'                                            '}${moment(this.clientIndependence.addedOn).format('DD-MMM-yyyy')}`,bold:true,margin:[0, 5, 0, 5]});
    docDefinition.content.push({text: `Assignments:${'                                                '}${this.clientIndependence.clientAssignment.map(res=>{
      return res.name
    })}`,bold:true,margin: [0, 5, 0, 5]});
    docDefinition.content.push({text: `Partner Assigned:${'                                          '}${this.clientIndependence.partnerFname} ${this.clientIndependence.partnerLname}`,bold:true,margin:[0, 5, 0, 5]});

    docDefinition.content.push({text: 'DETAILED DECLARATIONS',margin:[0, 15, 0, 5]});
    docDefinition.content.push({text: `${this.clientIndependence.beginText}`,bold:true,margin:[0, 5, 0, 10]});

    docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: [40, '*', 60],
          body: [
            [{ text: 'Sr. No', bold:true, margin: [0, 5, 0, 5] }, { text: 'Declaration', bold:true, margin: [0, 5, 0, 5] }, { text: '	Agree / Disagree', bold:true, margin: [0, 5, 0, 5] }],
            ...this.clientIndependence.declarationDetails.map((res,index) => [{ text:index+1 }, { text: res.question},  { text: `${res.answer?'Yes':'No'}`}]),
           
          ]
        }
      }
      );
      docDefinition.content.push({text: 'Explanation in cases where disagree responses are given',margin:[0, 15, 0, 0],bold:true});
      docDefinition.content.push({text: `${this.clientIndependence.dissagreementAnswer}`,margin:[0, 5, 0, 10]});
      docDefinition.content.push({text: `${this.clientIndependence.declaration}`,margin:[0, 15, 0, 10],bold:true});
      docDefinition.content.push({text: 'REPRESENTATION',margin:[0, 5, 0, 5],bold:true});
      docDefinition.content.push({text: `${this.clientIndependence.endText}`,margin:[0, 5, 0, 5],bold:true});
      docDefinition.content.push({text: `Sign:${'                         '} Yes`,margin: [0, 5, 0,4]});
      docDefinition.content.push({text: `Name:${'                       '}${this.clientIndependence.firstName} ${this.clientIndependence.lastName}`,margin:[0, 0, 0, 4]});
      docDefinition.content.push({text: `Designation:${'             '}${this.clientIndependence.role}`,margin:[0, 0, 0, 4]});
      docDefinition.content.push({text: `Date of joining:${'        '}${moment(this.clientIndependence.joiningDate).format('DD-MMM-yyyy')}`,margin:[0, 0, 0, 4]});
      docDefinition.content.push({text: `Date:${'                          '}${moment(this.clientIndependence.signedDate).format('DD-MMM-yyyy')}`,margin:[0, 0, 0, 4]});

    pdfMake.createPdf(docDefinition).download('NewClientDeclaration.pdf');
  }
}
